import $ from 'jquery';
import detectZoom from 'detect-zoom';

let initialZoom = detectZoom.device();

function isZoomed() {
    return detectZoom.device() > initialZoom;
}

function checkZoomAndReplaceTitleImage() {
    const logo = $('.logo-size-md');
    if (isZoomed()) {
        if (logo.hasClass('logo-image-replacement')) {
            logo.removeClass('logo-image-replacement')
        }
    } else {
        if (!logo.hasClass('logo-image-replacement')) {
            logo.addClass('logo-image-replacement')
        }
    }
}

$(() => {
    checkZoomAndReplaceTitleImage();
    $(window).resize(() => {
        checkZoomAndReplaceTitleImage();
    });
});
